/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fit': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<circle pid="0" cx="128" cy="128" r="23.5"/><path pid="1" d="M198.4 179.8l-16.6-16.6L217 128l-35.2-35.2 16.6-16.6 51.8 51.8zM57.6 179.8L5.8 128l51.8-51.8 16.6 16.6L39 128l35.2 35.2zM163.2 74.2L128 39 92.8 74.2 76.2 57.6 128 5.8l51.8 51.8zM128 250.2l-51.8-51.8 16.6-16.6L128 217l35.2-35.2 16.6 16.6z"/>'
  }
})
